import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { EChartsOption } from 'echarts';
import { BehaviorSubject, Observable } from 'rxjs';
import { GraphDataConfig } from 'src/app/objects/config';
import { ConfigDataService } from 'src/app/services/config-data.service';

@Component({
  selector: 'app-dynamic-echart',
  templateUrl: './dynamic-echart.component.html',
  styleUrls: ['./dynamic-echart.component.scss'],
})
export class DynamicEchartComponent implements OnInit, OnChanges {

  @Input() title: string;
  @Input() isShow: Observable<boolean> | boolean;
  @Input() infoPopover: (e: any) => Promise<any>;
  @Input() isLock = false;
  @Input() chartOption: EChartsOption;
  @Input() chartOption$: Observable<EChartsOption>;
  @Input() shouldShowSelector: boolean;
  @Input() multipleSelector: boolean;
  @Input() selectInterface: 'action-sheet' | 'popover' | 'alert' = 'alert';

  @Input() selectedOption$: BehaviorSubject<{ [selectorName: string]: { selected?: boolean; } & GraphDataConfig }>;
  @Input() selector: { [selectorName: string]: { selected?: boolean; } & GraphDataConfig } = {};
  @Input() chartLoading$: Observable<boolean>;

  selectedName: string[] = [];
  selectorName: string[] = [];

  constructor(
    public configDataService: ConfigDataService
  ) { }

  ngOnInit() {
    this.selectorName = Object.keys(this.selector);
    this.shouldShowSelector = this.selectorName && this.selectorName.length > 1;
    this.selectedName = Object.entries(this.selector).filter(([_, selectorDetail]) => selectorDetail.selected).map(([name, _]) => name);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.chartOption) {
      console.debug('In Dynamic', changes.chartOption);
      this.chartOption = changes.chartOption.currentValue;
    }
  }

  changeSelectedGraph(event: any) {
    const selectedName = event.detail.value as string[];
    this.selectedName = selectedName;
    const currentSelectedItem = this.selectedOption$.value;
    Object.keys(currentSelectedItem).forEach(selectorName => {
      currentSelectedItem[selectorName].selected = selectedName.includes(selectorName);
    });
    this.selectedOption$.next(currentSelectedItem);
  }

  get isShowGraph() {
    let showGraph = false;
    if (this.isShow instanceof Observable) {
      this.isShow.subscribe(show => {
        showGraph = show;
      });
    } else {
      showGraph = this.isShow;
    }

    return showGraph;
  }

}
